<template>
  <sp-select
    item-title="name"
    item-value="slotId"
    item-subtitle="details"
    return-object
    :items="visitTypes"
    :loading="isLoadingVisitTypes"
    :placeholder="placeholder"
    :disabled="!hasVisitTypes"
    @input="onVisitTypeSelect"
  />
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { usePhysicianApi } from "../api/physician";

const { find } = usePhysicianApi();

const emit = defineEmits(["update-selected"]);

const props = defineProps({
  physicianId: {
    type: String,
    required: true,
  },
});

const visitTypes = ref([]);
const isLoadingVisitTypes = ref(false);
const hasVisitTypes = computed(() => visitTypes.value?.length > 0);

const placeholder = computed(() => {
  if (isLoadingVisitTypes.value) {
    return;
  }

  if (!visitTypes.value?.length) {
    return "No visit types found";
  }

  return "Select a visit type...";
});

async function fetchVisitTypes() {
  if (!props.physicianId) {
    return;
  }

  try {
    isLoadingVisitTypes.value = true;

    const physician = await find(props.physicianId);
    visitTypes.value = physician.visitTypes;
  } catch (error) {
    console.error(error);
  } finally {
    isLoadingVisitTypes.value = false;
  }
}

function onVisitTypeSelect({ detail }) {
  const [visitType] = detail;
  emit("update-selected", visitType);
}

watch(() => props.physicianId, fetchVisitTypes, { immediate: true });
onMounted(fetchVisitTypes);
</script>
